import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { concat, from, of, Subscription, Observable, Subject } from 'rxjs';
import { map, switchMap, concatMap, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { Product, ProductInfo } from 'src/app/shared/product'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';

@Component({
  selector: 'app-product-list-invoiced',
  templateUrl: './product-list-invoiced.component.html',
  styleUrls: ['./product-list-invoiced.component.css']
})
export class ProductListInvoicedComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  rows: number = 20;
  totalRecords: number;
  loading: boolean = false;

  filterPRODCODE: string;
  filterPRODNAME: string;
  filterPRODVENDORNAME: string;
  filterPRODGROUPNAME: string;
  filterPRODSTOCK: number;
  filterPRODSOLD: number;
  filterPRODRESERV: number;
  filterPRODONHAND: number;

  monthToLoad: number = 6;

  productList: Product[];

  @ViewChild('prodTable') prodTable: Table;

  selectedProduct: Product;     // single Selection mode

  private _productQuery: Subscription;
  private _prodRowQuery: Subscription;

  private listOptions$ = new Subject<Date>();

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProductListInvoicedComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ProductListInvoicedComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProductListInvoicedComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'prodId':
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ProductListInvoicedComponent in ngOnDestroy')

    if (this._productQuery) { this._productQuery.unsubscribe(); }

    if (this._prodRowQuery) { this._prodRowQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** ProductListInvoicedComponent in ngOnInit')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    //environment.production || console.table(this.columns);

    this._productQuery =
      this.listOptions$.pipe(
        switchMap(date => {
          console.log('*** ProductListInvoicedComponent in listOptions$ switchMap: ' + date);

          //this.loading = true;

          return this.prodApi.getInvoicedProducts(date);
        }),

        concatMap(products => {
          this.totalRecords = products.length;
          this.productList = products;

          return from(products);
        }),

        concatMap(pr => this.prodApi.getProdInfoById(
          pr.PRODID,
          this.globalSettinsData.mainCompanyId,
          this.globalSettinsData.balanceCurrencyId,
          this.globalSettinsData.mainStockId,
          this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
          this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
          new Date()
        )
          .pipe(map(data => {
            let prodInfo: ProductInfo = data[0];
            pr.PRODSOLD = prodInfo.PRODSOLD;
            pr.PRODSTOCK = prodInfo.PRODSTOCK;
            pr.PRODONHAND = prodInfo.PRODONWAY;
            pr.PRODRESERV = prodInfo.PRODRESERVE;
          }), finalize(() => { /*this.loading = false;*/ }))),

        finalize(() => { this.loading = false; })
      )
        .subscribe();

    this.listOptions$.next(new Date());

  }

  clearOrResetTableFilter(event) {
    console.log('*** ProductListInvoicedComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.monthToLoad = 6;

    this.selectedProduct = null;
    this.filterPRODCODE =
      this.filterPRODNAME =
      this.filterPRODGROUPNAME =
      this.filterPRODVENDORNAME = '';

    this.filterPRODSTOCK =
      this.filterPRODSOLD =
      this.filterPRODRESERV =
      this.filterPRODONHAND = null;

    this.prodTable.clearState();
    this.prodTable.clear();

    this.listOptions$.next(new Date());
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** EditDocumentContentComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.productList);

      const exportData: any =
        this.productList.map(e => ({

          'Код товара': e.PRODCODE,
          'Наименование товара': e.PRODNAME,

          'Поставщик': e.PRODVENDORNAME,
          'Группа': e.PRODGROUPNAME,

          'На складе': e.PRODSTOCK,
          'Продано': e.PRODSOLD,
          'В резерве': e.PRODRESERV,
          'В пути': e.PRODONHAND,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { products: worksheet }, SheetNames: ['products'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "products");
    });
  }
}

